import { render, staticRenderFns } from "./addClientWarranty.vue?vue&type=template&id=4af56a42"
import script from "./addClientWarranty.vue?vue&type=script&lang=js"
export * from "./addClientWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports